export const ASSET_DOMAIN = import.meta.env.VITE_AWS_ASSET_DOMAIN
export const API_IMAGE_URL = import.meta.env.VITE_API_IMAGES_URL

export const topbarBg = '/breadcrumb-bg.svg';

export const logoUrl = `${ASSET_DOMAIN}/img/vf_defaqto_logo_stacked_white_v3.svg`

export const heart = '/vectors/heart.svg';
export const check = '/vectors/check.svg';
export const checkLight = '/vectors/check-light.svg';
export const messageCircleQuestion = '/vectors/message-circle-question.svg';
export const buildings = '/vectors/buildings.svg';

export const handshake = '/vectors/handshake.svg';
export const envelope = '/vectors/envelope.svg';
export const reply = '/vectors/reply.svg';
export const users = '/vectors/users.svg';
export const gridCheck = '/vectors/grid-check.svg';
export const gridCheckLight = '/vectors/grid-check-light.svg';
export const userRound = '/vectors/user-round.svg';
export const settings = '/vectors/settings.svg';
export const shieldAlert = '/vectors/shield-alert.svg';
export const activity = '/vectors/activity.svg';
export const filePptx = '/vectors/file-pptx.svg';
export const filePdf = '/vectors/file-pdf.svg';
export const layoutGrid = '/vectors/layout-grid.svg';

export const WIDGET_CODE_REVIEW_IMAGE = `${API_IMAGE_URL}/rating/VF_Final_Badge_Rating_No_Guides_5_Star_Stacked.png`
export const CERTIFICATE_OF_EXCELLENCE_PREVIEW_PDF = `${ASSET_DOMAIN}/img/accounts/reputation-tools/vf2023/reviews-pdf-vf-2023.png`
export const CAROUSEL_WIDGET_PREVIEW_DARK = `${ASSET_DOMAIN}/img/accounts/reputation-tools/vf2023/firm-reviews-widget-dark-vf-2023.png`
export const CAROUSEL_WIDGET_PREVIEW_LIGHT = `${ASSET_DOMAIN}/img/accounts/reputation-tools/vf2023/firm-reviews-widget-light-vf-2023.png`

export const TOP_RATED_CERTIFICATE_PREVIEW_PDF = `${ASSET_DOMAIN}/img/accounts/reputation-tools/vf2023/guide-top-rated-certificate-vf-2023.png`
